module.exports = __webpack_public_path__ + "img/warning.693cb658.svg";